export const BasicInfoLabel = 'Basic Information';

export const AppSteps = [
  { num: 1, route: 'select-account-type', label: 'Set up Account' },
  { num: 2, route: null, label: BasicInfoLabel },
  { num: 3, route: null, label: 'Submit' },
  { num: 4, route: null, label: 'Fund' },
  { num: 5, route: null, label: 'Enroll' }
];

export const QuestionnaireSteps = [
  { num: 1, route: 'cash-allocation', label: 'Questionnaire' },
  { num: 2, route: null, label: 'View Your Recommendation' },
  { num: 3, route: null, label: 'Open Account' }
];
